import { SET_AWS_CREDENTIALS, CLEAR_AWS_CREDENTIALS } from './awsAuthActionTypes'; // Path adjusted

const initialState = {
  encryptedCredentials: null,
};

const awsAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AWS_CREDENTIALS:
      return {
        ...state,
        encryptedCredentials: action.payload,
      };
    case CLEAR_AWS_CREDENTIALS:
      return {
        ...state,
        encryptedCredentials: null,
      };
    default:
      return state;
  }
};

export default awsAuthReducer;
